module.exports = __webpack_public_path__ + "img/coin_set.18ca24d6.png";